<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    description?: string
    items?: {
      title: string
      description?: string
      icon?: string
    }[]
  }>(),
  {
    title: 'Kirim Ratusan Pesanan Sekaligus dengan Akurasi & Efisiensi Tinggi',
    description:
      'Optimalkan produktivitas tim logistik dengan sistem otomatis untuk pengiriman massal — cepat, akurat, dan efisien.',
    items: () => [
      {
        title: 'Smart Data Mapping',
        description:
          'Sistem otomatis mengenali kolom data (nama, alamat, ekspedisi) dari template Excel tanpa format manual.',
        icon: 'material-symbols:map-outline'
      },
      {
        title: 'Auto Validation System',
        description:
          'Deteksi kesalahan atau duplikasi data sebelum pengiriman diproses, menjamin akurasi tinggi.',
        icon: 'material-symbols:check-circle-outline'
      },
      {
        title: 'Auto Label Printing',
        description:
          'Cetak label dan resi pengiriman massal secara otomatis, tanpa input per paket.',
        icon: 'material-symbols:print-outline'
      },
      {
        title: 'Centralized Tracking Dashboard',
        description:
          'Pantau status pengiriman seluruh paket dalam satu tampilan terpusat—real-time, lintas ekspedisi.',
        icon: 'material-symbols:share-location'
      }
    ]
  }
)
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container-highest py-6 lg:py-16"
  >
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle
        class="text-center"
        :title="title"
        :description="description"
      />
      <div class="grid lg:grid-cols-6 gap-5">
        <div class="lg:col-span-2 space-y-3">
          <UiCardFeature
            v-for="(item, key) in items"
            :key="key"
            :icon="item.icon"
            icon-size="24px"
            :title="item.title"
            wrapper-class="flex-row"
            title-class="lg:text-base"
            :description="item.description"
          />
        </div>

        <div class="lg:col-span-4">
          <UiPlayerYoutube video-id="Vzmm3LRA3-M" />
        </div>
      </div>
    </UiContainer>
  </div>
</template>
